import React, { useEffect, useState } from 'react';

import { Container, Image } from './ResourceImage.styles';
import { getImageResource } from '../../services/resources';

export default ({resourceId, isThumbnail, keepAspect}) => {

    const [imageData, setImageData] = useState('');

    useEffect(() => {
        let shouldSetData = true;

        (async () => {
            if (!resourceId) {
                if (shouldSetData) {
                    setImageData('');
                }
                return;
            }

            let data = await getImageResource(resourceId, isThumbnail || false)
            if (shouldSetData) {
                setImageData(data);
            }
        })();

        return () => {
            shouldSetData = false;
        };
    }, [resourceId, isThumbnail]);

    return <Container>
        {imageData && <Image className={keepAspect ? 'keepAspect' : ''} src={imageData} draggable="false" />}
    </Container>;
};